module.exports = __webpack_public_path__ + "static/media/castel3.3f1bbbae.jpg";